import { useQuery } from "@tanstack/react-query";
import { getAbout } from "../../api/apiAbout";

export const useGetAbout = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["about"],
        queryFn: getAbout,
    });

    return {
        about: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
